export * from './BaseTransformer';
export * from './CaseTransformer';
export * from './PatientTransformer';
export * from './RecordingTransformer';
export * from './TemplateTransformer';
export * from './UserTransformer';

// Transformer factory function
import { PatientTransformer } from './PatientTransformer';
import { RecordingTransformer } from './RecordingTransformer';
import { UserTransformer } from './UserTransformer';
import { CaseTransformer } from './CaseTransformer';
import { TemplateTransformer } from './TemplateTransformer';

export function createTransformer(entityType: string) {
  switch (entityType) {
    case 'Patient':
      return new PatientTransformer();
    case 'Recording':
      return new RecordingTransformer();
    case 'User':
      return new UserTransformer();
    case 'Case':
      return new CaseTransformer();
    case 'Template':
    case 'Section':
    case 'Textbox':
      return new TemplateTransformer();
    default:
      throw new Error(`No transformer available for entity type: ${entityType}`);
  }
}
